import React from "react";
import { useHistory } from "react-router-dom";
import newsGeneralWallStreetImage from "../../../../../assets/images/NewsRoomImages/news-journal-wallstreet-image.webp";
import newsImage1 from "../../../../../assets/images/NewsRoomImages/newsImage1.webp";
import newsImage2 from "../../../../../assets/images/NewsRoomImages/newsImage2.png";
import newsImage3 from "../../../../../assets/images/NewsRoomImages/newsImage3.png";
import newsImage4 from "../../../../../assets/images/NewsRoomImages/newsImage4.svg";
import newsImage5 from "../../../../../assets/images/NewsRoomImages/newsImage5.svg";
import newsImage6 from "../../../../../assets/images/NewsRoomImages/newsImage6.svg";
import newsImage7 from "../../../../../assets/images/NewsRoomImages/newsImage7.svg";
import newsImage8 from "../../../../../assets/images/NewsRoomImages/Food Logistics.png";
import newsImage9 from "../../../../../assets/images/NewsRoomImages/newsImage9.svg";
import newsImage10 from "../../../../../assets/images/NewsRoomImages/newsImage10.svg";
import newsImage11 from "../../../../../assets/images/NewsRoomImages/DC-Velocity.png";
import newsImage13 from "../../../../../assets/images/NewsRoomImages/FreightWaves_Vaccaro Interview_Screenshot.webp";
import newsImage14 from "../../../../../assets/images/NewsRoomImages/kevin-kull-edited2.png";
import newsImage17 from "../../../../../assets/images/NewsRoomImages/What The Truck_Screenshot.webp";
import {
  Container,
  Wrapper,
  Box,
} from "web/pages/public/landing-page/NewsRoom/NewsLetter/NewsLetterStyled";

const newsImageUrlsData = [
  {
    id: 1,
    newsImg: newsGeneralWallStreetImage,
    newsHeader:
      "Bettaway Supply Chain Services launched an online pallet-trading marketplace.",
    newsPara: "",
    watchUrl: "/wsj-link",
    newsImageMore: "Read The Story",
  },
  {
    id: 2,
    newsImg: newsImage1,
    newsHeader:
      "PalletTrader founder John Vaccaro tells the story of launching the new online marketplace for pallet buyers and sellers",
    newsPara:
      "How a supply chain industry first was born, and what the innovative new service will mean for pallet buyers and sellers everywhere…",
    watchUrl: "https://vimeo.com/user95421731/download/769507338/4c64f35fb2",
    newsImageMore: "Watch The Interview",
  },

  {
    id: 3,
    newsImg: newsImage2,
    newsHeader:
      "PalletTrader is introduced to the supply chain industry at the FreightWaves F3 show.",
    newsPara:
      "Industry leaders got their first look at the world’s first online marketplace for buying and selling pallets in a live demo at F3…",
    watchUrl: "https://vimeo.com/768212538",
    newsImageMore: "Watch The Demo",
  },
  {
    id: 4,
    newsImg: newsImage11,
    newsHeader:
      "Pallet-trading website would bring digital platform to outdated market",
    newsPara:
      "An online pallet-trading marketplace that launched today could help relieve a long-running pallet supply crisis forced by outdated, manual processes…",
    watchUrl:
      "https://www.dcvelocity.com/articles/55795-pallet-trading-website-would-bring-digital-platform-to-outdated-market",
    newsImageMore: "Read More",
  },
  {
    id: 5,
    newsImg: newsImage6,
    newsHeader:
      "Influenced by everything from eBay to the DAT Load Board, PalletTrader is the first online pallet marketplace",
    newsPara:
      "Powered by Bettaway, PalletTrader is a sophisticated yet user-friendly e-commerce solution designed for everyone associated with the buying and selling…",
    watchUrl: "https://www.inboundlogistics.com/articles/pallets-front-and-center/",
    newsImageMore: "Read More",
  },

  {
    id: 6,
    newsImg: newsImage5,
    newsHeader:
      "PalletTrader launches online platform, built exclusively for the sourcing, buying and selling of commercial wooden pallets PalletTrader launched Oct. 20 as an online platform, designed and",
    newsPara:
      "PalletTrader launched Oct. 20 as an online platform, designed and built exclusively for the sourcing, buying and selling of commercial wooden pallets…",
    watchUrl:
      "https://www.supplychainbrain.com/articles/35905-pallettrader-launches-as-supply-chain-industrys-first-marketplace-for-sourcing-buying-and-selling-wooden-pallets",
    newsImageMore: "Read More",
  },
  {
    id: 7,
    newsImg: newsImage3,
    newsHeader:
      "Pallets finally get their due with online marketplace for buyers, sellers",
    newsPara:
      "How a supply chain industry first was born, and what the innovative new service will mean for pallet buyers and sellers everywhere…",
    watchUrl: "https://www.freightwaves.com/news/tag/pallettrader",
    newsImageMore: "Read More",
  },
  {
    id: 8,
    newsImg: newsImage4,
    newsHeader:
      "PalletTrader is introduced to the supply chain industry at the FreightWaves F3 show",
    newsPara:
      "Industry leaders got their first look at the world’s first online marketplace for buying and selling pallets in a live demo at F3…",
    watchUrl:
      "https://www.palletenterprise.com/view_article/5762/Online-Marketplace-Launched-for-Buying-and-Selling-Pallets-",
    newsImageMore: "Read More",
  },

  {
    id: 9,
    newsImg: newsImage7,
    newsHeader:
      "PalletTrader Launches as Supply Chain Industry’s New Marketplace for Sourcing, Buying and Selling Wooden Pallets",
    newsPara:
      "The ubiquitous wooden pallet, which is critical to every business’ supply chain as the platform on which millions of shipments ride in trucks and trains every day…",
    watchUrl:
      "https://www.bevnet.com/news/supplier-news/2022/pallettrader-launches-as-supply-chain-industrys-first-marketplace-for-sourcing-buying-and-selling-wooden-pallets/",
    newsImageMore: "Read More",
  },
  {
    id: 10,
    newsImg: newsImage8,
    newsHeader:
      "PalletTrader marketplace for sourcing, buying, selling wooden pallets",
    newsPara:
      "PalletTrader enables and streamlines the digital trading and sale of pallets in a collaborative, secure e-commerce environment, providing the user community with workflows and tools to drive new efficiencies into pallet supply…",
    watchUrl:
      "https://www.foodlogistics.com/warehousing/news/22525835/bettaway-supply-chain-services-pallettrader-marketplace-for-sourcing-buying-selling-wooden-pallets",
    newsImageMore: "Read More",
  },
  {
    id: 11,
    newsImg: newsImage9,
    newsHeader:
      "Introducing a revolutionary new online marketplace helping to combat pallet reuse inefficiencies",
    newsPara:
      " Nothing in a truck is stored or moved without a pallet under it. With more than 500 million units in circulation, pallets are often bought and sold throughout the industry by pallet recyclers…",
    watchUrl:
      "https://freightalent.com/freight-news/worlds-first-online-marketplace-helping-to-combat-pallet-reuse-inefficiencies/",
    newsImageMore: "Read More",
  },
  {
    id: 12,
    newsImg: newsImage10,
    newsHeader: "FreightWaves announces Best in Show winners at F3",
    newsPara:
      "After three days of rapid-fire demos — during which presenters were given seven minutes to show off their latest FreightTech solutions — FreightWaves is excited to announce 2022’s Future of Freight Festival Best in Show winners…",
    watchUrl:
      "https://www.freightwaves.com/news/freightwaves-announces-best-in-show-winners-at-f3",
    newsImageMore: "Read More",
  },
  {
    id: 14,
    newsImg: newsImage13,
    newsHeader: "PalletTrader Founder and President John Vaccaro shares the PalletTrader story on FreightWaves TV",
    newsPara:
      "PalletTrader is shaking up the industry by changing how pallets, a necessary commodity in the logistics industry, are traded and sold…",
    watchUrl:
      "https://tv.freightwaves.com/details/34319?playlist_id=50",
    newsImageMore: "Watch The Demo",
  },
  {
    id: 15,
    newsImg: newsImage14,
    newsHeader: "Logistics Industry Veteran Kevin Kull Joins PalletTrader as SVP of Sales and Operations",
    newsPara:
      "PalletTrader, a new online marketplace built exclusively for the sourcing, buying and selling of wooden pallets, announced today that Kevin Kull…",
    watchUrl:
      "https://www.einpresswire.com/article/602500443/logistics-industry-veteran-kevin-kull-joins-pallettrader-as-svp-of-sales-and-operations",
    newsImageMore: "Read More",
  },
  {
    id: 19,
    newsImg: newsImage17,
    newsHeader: "What the humble pallet says about the market.",
    newsPara:
      "On this episode of WHAT THE TRUCK?!? Dooner is talking with Kevin Kull about the role the humble pallet plays in the supply chain…",
    watchUrl:
      "https://www.freightwaves.com/news/what-the-humble-pallet-says-about-the-market-wtt",
    newsImageMore: "Read More",
  },
];

const NewsLetter = () => {
  let history = useHistory();

  return (
    <Container>
      <Wrapper>
        {newsImageUrlsData.map((e) => {
          return (
            <Box
              style={{ background: e.id % 2 === 0 ? `#95cce9` : `#095587` }}
              key={e.id}
            >
              <a
                href={e.watchUrl.startsWith("http") ? e.watchUrl : ""}
                target="_blank"
                onClick={(event) => {
                  if (!e.watchUrl.startsWith("http")) {
                    event.preventDefault();
                    history.push(e.watchUrl);
                  }
                }}
              >
                <img
                  src={e.newsImg}
                  alt="Revolutionary"
                  style={{
                    padding: e.id === 10 /* || e.id === 9 */ ? "10px" : "0px",
                  }}
                />
              </a>
              <div className="text-section">
                <h4>{e.newsHeader}</h4>
                <p>{e.newsPara}</p>
                <a
                  className="link"
                  href={e.watchUrl.startsWith("http") ? e.watchUrl : ""}
                  target="_blank"
                  onClick={(event) => {
                    if (!e.watchUrl.startsWith("http")) {
                      event.preventDefault();
                      history.push(e.watchUrl);
                    }
                  }}
                >
                  {e.newsImageMore}
                </a>
              </div>
            </Box>
          );
        })}
      </Wrapper>
    </Container>
  );
};

export default NewsLetter;
